import { Link } from "react-router-dom";
import { PageLayout } from "@/components/PageLayout";
import { CalculatorCard } from "@/components/CalculatorCard";
import { calculators } from "@/data/calculators";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CreditCard, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import logoLight from "@/assets/logo-light_t.png";
import logoDark from "@/assets/logo-dark_t.png";
import { useTranslation } from "react-i18next";
import { useLanguageAwareSEO } from "@/hooks/useLanguageAwareSEO";
import { breadcrumbSchema } from "@/utils/structuredData";

export default function Loans() {
  const { t } = useTranslation();
  const loanCalculators = calculators.filter(calc => calc.category === "finance" && calc.subcategory === "Loans");

  useLanguageAwareSEO([
    (lang) => breadcrumbSchema([
      { name: "Home", url: "https://calclab.app" },
      { name: t('categories.pages.loans.title'), url: "https://calclab.app/loans" }
    ], lang)
  ]);

  return (
    <PageLayout>
      <div className="space-y-8">
        <div className="text-center space-y-4">
          <div className="flex justify-center">
            <CreditCard className="h-16 w-16 text-primary" />
          </div>
          <h1 className="text-4xl font-bold tracking-tight">{t('categories.pages.loans.title')}</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('categories.pages.loans.description')}
          </p>
        </div>

        <Card className="border-primary/20">
          <CardHeader>
            <CardTitle>{t('categories.pages.loans.cardTitle')}</CardTitle>
            <CardDescription>
              {t('categories.pages.loans.cardDescription')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              {t('categories.pages.loans.cardContent')}
            </p>
          </CardContent>
        </Card>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {loanCalculators.map(calculator => (
            <CalculatorCard key={calculator.id} {...calculator} />
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
